(() => {
  const HULK_VALIDATION_FALLBACK_DELAY_MS = 150;
  const HULK_VALIDATION_SETTLE_DELAY_MS = 50;
  const HULK_VALIDATION_TIMEOUT_MS = 1000;
  const MAX_INIT_ATTEMPTS = 40;
  const INIT_RETRY_DELAY_MS = 250;
  const HULK_TYPE = "hulkapps_product_options";
  const INTAKE_PRODUCT_HANDLE = "order-intake-deta";
  const PLP_REDIRECT_PATH = "/collections/spawts-keepsake-collection";
  const BUY_BUTTONS_BLOCK_SELECTOR = ".buy-buttons-block";
  const PRODUCT_FORM_SELECTOR = "product-form-component[data-product-id]";
  const STICKY_ATC_SELECTOR = "sticky-add-to-cart[data-product-id]";
  const HULK_WRAPPER_SELECTOR = '[id^="hulkapps_option_list_"]';
  const PLURAL_CART_TRIGGER_SELECTOR = ".aasaved-cart-trigger";
  const PLURAL_CART_EXPAND_SELECTOR = ".aasaved-cart-more";
  const PLURAL_CART_MODAL_SELECTOR = ".cs-modal";
  const PLURAL_CART_MODAL_OPEN_SELECTOR = ".cs-modal.open";
  const PLURAL_CART_ITEM_SELECTOR = ".aasaved-cart-item";
  const PLURAL_CART_ITEM_ID_SELECTOR = ".aasaved-cart-subdued";
  const PLURAL_CART_SUCCESS_SELECTOR = ".aasaved-cart-success";
  const PLURAL_CART_DISABLED_NOTE_CLASS = "aasaved-cart-item-note";
  const PLURAL_CART_DISABLED_MESSAGE =
    "This draft cart already contains an intake form.";
  const SECTION_SELECTOR = '[id^="shopify-section-"]';
  const HULK_FILE_PROPERTY_SELECTOR = 'input[type="file"][name^="properties["]';
  const HULK_FILE_URL_ATTR = "data-hulk-pluralcart-file-url";
  const HULK_FILE_DISABLED_ATTR = "data-hulk-pluralcart-file-disabled";
  const HULK_UPLOAD_PROBE_PROPERTY =
    "properties[_hulk_pluralcart_upload_probe]";
  const DRAFT_NAME_PREFILLED_ATTR = "data-hulk-draft-name-prefilled";

  const showConfirmDialog = (title, message) => {
    return new Promise((resolve) => {
      const overlay = document.createElement('div');
      overlay.style.cssText = [
        'display: flex',
        'position: fixed',
        'top: 0',
        'left: 0',
        'width: 100%',
        'height: 100%',
        'justify-content: center',
        'align-items: center',
        'background: rgba(0, 0, 0, 0.5)',
        'opacity: 0',
        'transition: opacity 0.2s ease',
        'z-index: 99999',
      ].join(';');

      const modal = document.createElement('div');
      modal.style.cssText = [
        'background: #fff',
        'border-radius: 8px',
        'max-width: 440px',
        'width: 90%',
        'box-shadow: 0 8px 32px rgba(0,0,0,0.18)',
        'position: relative',
      ].join(';');

      modal.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:space-between;padding:15px;">
          <span data-slot="title" style="font-size:1.5rem;font-weight:600;color:#111;"></span>
          <button data-action="cancel" aria-label="Close" style="background:none;border:none;cursor:pointer;padding:0.25rem;font-size:1.25rem;line-height:1;color:#555;">&#x2715;</button>
        </div>
        <div style="padding:15px;border-bottom:1px solid #ddd;">
          <p data-slot="message" style="margin:0;font-size:0.9375rem;line-height:1.5;color:#444;"></p>
        </div>
        <div style="display:flex;gap:0.75rem;justify-content:flex-end;padding:15px;">
          <button data-action="cancel" style="padding:0.6rem 1.25rem;border:1px solid #ccc;border-radius:4px;background:#fff;cursor:pointer;font-size:0.9375rem;color:#111;font-weight:700;">Cancel</button>
          <button data-action="confirm" style="padding:0.6rem 1.25rem;border:1px solid #111;border-radius:4px;background:#111;color:#fff;cursor:pointer;font-size:0.9375rem;font-weight:700;">Confirm</button>
        </div>
      `;
      modal.querySelector('[data-slot="title"]').textContent = title;
      modal.querySelector('[data-slot="message"]').textContent = message;

      overlay.appendChild(modal);

      let resolved = false;

      const onKeydown = (e) => {
        if (e.key === 'Escape') {
          cleanup(false);
        }
      };

      const cleanup = (result) => {
        if (resolved) return;
        resolved = true;
        document.removeEventListener('keydown', onKeydown);
        overlay.remove();
        resolve(result);
      };

      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
        if (e.target === overlay) {
          cleanup(false);
          return;
        }
        const action = e.target.closest('[data-action]')?.dataset?.action;
        if (action === 'confirm') cleanup(true);
        else if (action === 'cancel') cleanup(false);
      });

      document.addEventListener('keydown', onKeydown);

      document.body.appendChild(overlay);
      requestAnimationFrame(() => { overlay.style.opacity = '1'; });
    });
  };

  // --- Draft Cart: Add All to Cart & Add Single Item to Cart ---

  const DRAFT_CART_PATH_PATTERN = /\/a\/saved-carts\/([^/?#]+)/;
  const ADD_ALL_TO_CART_SELECTOR = '[data-action~="show#replaceCart"]';
  const ADD_SINGLE_TO_CART_SELECTOR = '[data-action~="show#addToCart"]';

  const state = window.__hulkPluralCartIntegrationState || {};

  if (state.initStarted) {
    return;
  }

  state.initStarted = true;
  state.lastProductId = state.lastProductId || null;
  state.savedCartIntakeCache = state.savedCartIntakeCache || {};
  state.savedCartDetailPromises = state.savedCartDetailPromises || {};
  state.currentCartHasIntakePromise = state.currentCartHasIntakePromise || null;
  window.__hulkPluralCartIntegrationState = state;

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const getTemplateName = () => {
    return (
      document.querySelector("main[data-template]")?.dataset?.template || ""
    );
  };

  const isProductTemplate = () => getTemplateName().startsWith("product");

  const isCartTemplate = () => getTemplateName().startsWith("cart");

  const isVisible = (element) => {
    return !!(
      element &&
      (element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length)
    );
  };

  const getProductIdFromWrapper = (wrapper) => {
    const match = wrapper?.id?.match(/^hulkapps_option_list_(.+)$/);
    return match ? match[1] : null;
  };

  const getVisibleHulkWrapper = () => {
    return (
      [...document.querySelectorAll(HULK_WRAPPER_SELECTOR)].find(isVisible) ||
      null
    );
  };

  const getProductIdFromScope = (scope) => {
    if (!scope) {
      return null;
    }

    const productForm = scope.querySelector(PRODUCT_FORM_SELECTOR);

    if (productForm?.dataset?.productId) {
      return productForm.dataset.productId;
    }

    const stickyAddToCart = scope.querySelector(STICKY_ATC_SELECTOR);

    if (stickyAddToCart?.dataset?.productId) {
      return stickyAddToCart.dataset.productId;
    }

    return null;
  };

  const getProductIdFromElement = (element) => {
    const block = element?.closest(BUY_BUTTONS_BLOCK_SELECTOR);
    const blockProductId = getProductIdFromScope(block);

    if (blockProductId) {
      return blockProductId;
    }

    const section = element?.closest(SECTION_SELECTOR);
    const sectionProductId = getProductIdFromScope(section);

    if (sectionProductId) {
      return sectionProductId;
    }

    return getProductIdFromWrapper(getVisibleHulkWrapper());
  };

  const getCurrentProductId = () => {
    if (state.lastProductId) {
      return state.lastProductId;
    }

    const visibleHulkProductId = getProductIdFromWrapper(
      getVisibleHulkWrapper(),
    );

    if (visibleHulkProductId) {
      return visibleHulkProductId;
    }

    return getProductIdFromScope(document);
  };

  const getCurrentProductForm = () => {
    const visibleProductForm = [
      ...document.querySelectorAll(PRODUCT_FORM_SELECTOR),
    ].find(isVisible);

    if (visibleProductForm) {
      return visibleProductForm;
    }

    return document.querySelector(PRODUCT_FORM_SELECTOR);
  };

  const isCurrentProductIntakeForm = () => {
    const productForm = getCurrentProductForm();
    const productUrl = productForm?.dataset?.productUrl || "";

    return (
      productUrl.includes(INTAKE_PRODUCT_HANDLE) ||
      window.location.pathname.includes(`/products/${INTAKE_PRODUCT_HANDLE}`)
    );
  };

  const getHulkWrapper = (productId) => {
    if (productId) {
      return document.getElementById(`hulkapps_option_list_${productId}`);
    }

    return getVisibleHulkWrapper();
  };

  const hasValue = (field) => {
    const radios = [...field.querySelectorAll('input[type="radio"]')].filter(
      (input) => !input.disabled,
    );

    if (radios.length) {
      return radios.some((input) => input.checked);
    }

    const checkboxes = [
      ...field.querySelectorAll('input[type="checkbox"]'),
    ].filter((input) => !input.disabled);

    if (checkboxes.length) {
      return checkboxes.some((input) => input.checked);
    }

    const select = field.querySelector("select");

    if (select && !select.disabled) {
      return Boolean((select.value || "").trim());
    }

    const textInput = field.querySelector(
      'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea',
    );

    if (textInput && !textInput.disabled && isVisible(textInput)) {
      return Boolean((textInput.value || "").trim());
    }

    return false;
  };

  const waitForHulkValidationRender = (productId) => {
    return new Promise((resolve) => {
      const observerTarget = getHulkWrapper(productId) || document.body;
      let settleTimerId = null;
      let fallbackTimerId = null;
      let timeoutTimerId = null;
      let sawMutation = false;

      const cleanup = (observer) => {
        observer.disconnect();
        window.clearTimeout(settleTimerId);
        window.clearTimeout(fallbackTimerId);
        window.clearTimeout(timeoutTimerId);
        resolve();
      };

      const observer = new MutationObserver(() => {
        sawMutation = true;

        window.clearTimeout(settleTimerId);
        settleTimerId = window.setTimeout(
          () => cleanup(observer),
          HULK_VALIDATION_SETTLE_DELAY_MS,
        );
      });

      observer.observe(observerTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });

      fallbackTimerId = window.setTimeout(() => {
        if (!sawMutation) {
          cleanup(observer);
        }
      }, HULK_VALIDATION_FALLBACK_DELAY_MS);

      timeoutTimerId = window.setTimeout(
        () => cleanup(observer),
        HULK_VALIDATION_TIMEOUT_MS,
      );
    });
  };

  const isHulkValid = async (productId) => {
    const resolvedProductId = productId || getCurrentProductId();

    if (!resolvedProductId) {
      return false;
    }

    state.lastProductId = resolvedProductId;

    const wrapper = getHulkWrapper(resolvedProductId);

    if (!wrapper) {
      return true;
    }

    if (typeof window.validate_options === "function") {
      const waitForRender = waitForHulkValidationRender(resolvedProductId);
      window.validate_options(resolvedProductId, HULK_TYPE);
      await waitForRender;
    }

    const requiredFields = [...wrapper.querySelectorAll(".required")].filter(
      isVisible,
    );
    const visibleErrors = [
      ...wrapper.querySelectorAll(".validation_error"),
    ].filter((element) => {
      return isVisible(element) && (element.textContent || "").trim() !== "";
    });

    return requiredFields.every(hasValue) && visibleErrors.length === 0;
  };

  const closePluralCartModal = () => {
    if (typeof window.cartSaver?.closeSelector === "function") {
      window.cartSaver.closeSelector();
      return;
    }

    if (typeof window.cartSaver?.closeModal === "function") {
      window.cartSaver.closeModal();
    }
  };

  const openPluralCartModal = () => {
    if (typeof window.cartSaver?.openSelector === "function") {
      window.cartSaver.openSelector();
    }
  };

  const showHulkFilePreparationError = () => {
    window.alert(
      "We couldn't prepare the uploaded file for this draft cart. Please try again.",
    );
  };

  const redirectToPlp = () => {
    if (state.redirectExecuted) {
      return;
    }

    state.redirectExecuted = true;
    window.location.assign(PLP_REDIRECT_PATH);
  };

  const fetchJson = async (url) => {
    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Request failed for ${url}`);
    }

    return response.json();
  };

  const savedCartHasIntakeForm = async (cartId) => {
    if (!cartId) {
      return false;
    }

    if (
      Object.prototype.hasOwnProperty.call(state.savedCartIntakeCache, cartId)
    ) {
      return state.savedCartIntakeCache[cartId];
    }

    if (!state.savedCartDetailPromises[cartId]) {
      state.savedCartDetailPromises[cartId] = fetchJson(
        `/a/saved-carts/${encodeURIComponent(cartId)}`,
      )
        .then((savedCart) => {
          const hasIntake = Array.isArray(savedCart?.items)
            ? savedCart.items.some(
                (item) => item?.handle === INTAKE_PRODUCT_HANDLE,
              )
            : false;

          state.savedCartIntakeCache[cartId] = hasIntake;

          return hasIntake;
        })
        .catch((error) => {
          console.error(error);
          state.savedCartIntakeCache[cartId] = false;
          return false;
        })
        .finally(() => {
          delete state.savedCartDetailPromises[cartId];
        });
    }

    return state.savedCartDetailPromises[cartId];
  };

  const currentCartHasIntakeForm = async () => {
    if (state.currentCartHasIntakePromise) {
      return state.currentCartHasIntakePromise;
    }

    state.currentCartHasIntakePromise = fetchJson("/cart.js")
      .then((cart) => {
        return Array.isArray(cart?.items)
          ? cart.items.some((item) => item?.handle === INTAKE_PRODUCT_HANDLE)
          : false;
      })
      .catch((error) => {
        console.error(error);
        state.currentCartHasIntakePromise = null;
        return false;
      });

    return state.currentCartHasIntakePromise;
  };

  const getCartIdFromCartItem = (item) => {
    return item
      ?.querySelector(PLURAL_CART_ITEM_ID_SELECTOR)
      ?.textContent?.trim();
  };

  const setCartItemDisabledState = (item, disabled) => {
    if (!item) {
      return;
    }

    let note = item.querySelector(`.${PLURAL_CART_DISABLED_NOTE_CLASS}`);

    if (disabled && !note) {
      note = document.createElement("span");
      note.className = PLURAL_CART_DISABLED_NOTE_CLASS;
      note.textContent = PLURAL_CART_DISABLED_MESSAGE;
      item.appendChild(note);
    }

    item.dataset.intakeDisabled = disabled ? "true" : "false";
    item.setAttribute("aria-disabled", disabled ? "true" : "false");
    item.classList.toggle("aasaved-cart-item--disabled", disabled);

    if (!disabled && note) {
      note.remove();
    }
  };

  const clearDisabledStates = (modal) => {
    modal.querySelectorAll(PLURAL_CART_ITEM_SELECTOR).forEach((item) => {
      setCartItemDisabledState(item, false);
    });
  };

  const shouldApplyDraftCartLimit = async () => {
    if (isProductTemplate()) {
      return isCurrentProductIntakeForm();
    }

    if (isCartTemplate()) {
      return currentCartHasIntakeForm();
    }

    return false;
  };

  const normalizeLabel = (label) =>
    (label || "").replace(/[\u2018\u2019\u2032']/g, "'").replace(/\s+/g, " ").trim().toLowerCase();

  const getHulkFieldValue = (wrapper, labelMatch) => {
    if (!wrapper) return "";
    const inputs = wrapper.querySelectorAll('input[name^="properties["]');
    for (const input of inputs) {
      const label = normalizeLabel(getPropertyLabel(input.name));
      if (label === normalizeLabel(labelMatch)) {
        return (input.value || "").trim();
      }
    }
    return "";
  };

  const buildDraftCartName = () => {
    const wrapper = getVisibleHulkWrapper();
    if (!wrapper) return "";
    const petName = getHulkFieldValue(wrapper, "Pet's Name");
    const ownerName = getHulkFieldValue(wrapper, "Owner Name");
    if (!petName || !ownerName) return "";
    const ownerLastName = ownerName.split(/\s+/).pop();
    return `${petName} ${ownerLastName}`;
  };

  const buildDraftCartNameFromIntakeProperties = (properties) => {
    if (!properties) return "";
    let petName = "";
    let ownerName = "";
    for (const [key, value] of Object.entries(properties)) {
      const normalizedKey = normalizeLabel(key);
      if (normalizedKey === "pet's name") {
        petName = (value || "").trim();
      } else if (normalizedKey === "owner name") {
        ownerName = (value || "").trim();
      }
    }
    if (!petName || !ownerName) return "";
    const ownerLastName = ownerName.split(/\s+/).pop();
    return `${petName} ${ownerLastName}`;
  };

  const buildDraftCartNameFromCart = async () => {
    try {
      const cart = await fetchJson("/cart.js");
      const intakeItem = Array.isArray(cart?.items)
        ? cart.items.find((item) => item?.handle === INTAKE_PRODUCT_HANDLE)
        : null;
      if (!intakeItem?.properties) return "";
      return buildDraftCartNameFromIntakeProperties(intakeItem.properties);
    } catch {
      return "";
    }
  };

  const prefillDraftCartName = async (modal) => {
    const input = modal.querySelector("input.aasaved-cart-create-new-title");
    if (!input || input.getAttribute(DRAFT_NAME_PREFILLED_ATTR) === "true") return;

    input.setAttribute(DRAFT_NAME_PREFILLED_ATTR, "true");

    let name = "";

    if (isProductTemplate() && isCurrentProductIntakeForm()) {
      name = buildDraftCartName();
    } else if (isCartTemplate()) {
      name = await buildDraftCartNameFromCart();
      if (input.value.trim()) return;
    }

    if (!name) return;
    input.value = name;
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  };

  const decoratePluralCartModal = async (modal) => {
    const listElement = modal?.querySelector(".aasaved-cart-list");

    if (!listElement) {
      return;
    }

    const shouldApply = await shouldApplyDraftCartLimit();

    if (!shouldApply) {
      clearDisabledStates(modal);
      return;
    }

    const items = [...listElement.querySelectorAll(PLURAL_CART_ITEM_SELECTOR)];

    await Promise.all(
      items.map(async (item) => {
        const cartId = getCartIdFromCartItem(item);
        const hasIntake = await savedCartHasIntakeForm(cartId);
        setCartItemDisabledState(item, hasIntake);
      }),
    );
  };

  const handlePluralCartSuccessRedirect = (modal) => {
    if (!isProductTemplate() || state.redirectInFlight) {
      return;
    }

    const successElement = modal?.querySelector(PLURAL_CART_SUCCESS_SELECTOR);

    if (!successElement || !isVisible(successElement)) {
      return;
    }

    state.redirectInFlight = true;
    window.setTimeout(() => {
      redirectToPlp();
    }, 150);
  };

  const handleCartPageSaveToDraftSuccess = (modal) => {
    if (!isCartTemplate() || state.cartReloadInFlight) {
      return;
    }

    const successElement = modal?.querySelector(PLURAL_CART_SUCCESS_SELECTOR);

    if (!successElement || !isVisible(successElement)) {
      return;
    }

    state.cartReloadInFlight = true;
    window.setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const installDisabledCartStyles = () => {
    if (document.getElementById("pluralcart-intake-guard-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "pluralcart-intake-guard-styles";
    style.textContent = `
      .aasaved-cart-item--disabled {
        opacity: 0.45;
        cursor: not-allowed;
        position: relative;
      }

      .aasaved-cart-item--disabled .aasaved-cart-item-title,
      .aasaved-cart-item--disabled .aasaved-cart-subdued {
        pointer-events: none;
      }

      .${PLURAL_CART_DISABLED_NOTE_CLASS} {
        display: block;
        color: #b42318;
        font-size: 0.875rem;
        line-height: 1.3;
        opacity: 1;
      }
    `;

    document.head.appendChild(style);
  };

  const installModalObserver = () => {
    if (state.modalObserverInstalled) {
      return;
    }

    const observer = new MutationObserver(() => {
      scheduleModalDecoration();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"],
    });

    state.modalObserverInstalled = true;
    state.modalObserver = observer;
  };

  const handleDisabledCartInteraction = (event) => {
    const item = event.target.closest(
      `${PLURAL_CART_MODAL_SELECTOR} ${PLURAL_CART_ITEM_SELECTOR}[data-intake-disabled="true"]`,
    );

    if (!item) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  const handleDisabledCartKeydown = (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    handleDisabledCartInteraction(event);
  };

  const clearHulkFileUrlInputs = (form) => {
    form
      .querySelectorAll(`[${HULK_FILE_DISABLED_ATTR}="true"]`)
      .forEach((input) => {
        input.disabled = false;
        input.removeAttribute(HULK_FILE_DISABLED_ATTR);
      });

    form
      .querySelectorAll(`[${HULK_FILE_URL_ATTR}="true"]`)
      .forEach((node) => node.remove());
  };

  const getPropertyLabel = (name) => {
    const match = `${name || ""}`.match(/^properties\[(.*)]$/);
    return match ? match[1] : name;
  };

  const getLineItemProperty = (properties, inputName) => {
    const propertyLabel = getPropertyLabel(inputName);
    if (Array.isArray(properties)) {
      return (
        properties.find((item) => {
          return item?.name === propertyLabel || item?.name === inputName;
        })?.value || ""
      );
    }

    return properties?.[propertyLabel] || properties?.[inputName] || "";
  };

  const isUsableFileValue = (value) => {
    const stringValue = `${value || ""}`.trim();

    return Boolean(stringValue && !stringValue.includes("fakepath"));
  };

  const addProbeCartLine = async (form, fileInputs) => {
    const formData = new FormData(form);
    formData.set(
      HULK_UPLOAD_PROBE_PROPERTY,
      `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    );

    fileInputs.forEach((input) => {
      formData.set(input.name, input.files[0], input.files[0].name);
    });

    const response = await fetch(
      Theme?.routes?.cart_add_url || "/cart/add.js",
      {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      },
    );

    if (!response.ok) {
      throw new Error("Unable to upload Hulk file option.");
    }

    return response.json();
  };

  const removeProbeCartLine = async (item) => {
    if (!item?.key) {
      return;
    }

    const response = await fetch(
      Theme?.routes?.cart_change_url || "/cart/change.js",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
        }),
      },
    );

    if (!response.ok) {
      throw new Error("Unable to remove Hulk probe cart line.");
    }
  };

  const getHulkFileUrlsFromCartProbe = async (form, fileInputs) => {
    let item = null;
    let values = {};

    try {
      item = await addProbeCartLine(form, fileInputs);

      values = fileInputs.reduce((result, input) => {
        const value = getLineItemProperty(item?.properties, input.name);

        if (isUsableFileValue(value)) {
          result[input.name] = value;
        }

        return result;
      }, {});
    } finally {
      if (item) {
        try {
          await removeProbeCartLine(item);
        } catch (firstError) {
          await wait(200);
          try {
            await removeProbeCartLine(item);
          } catch (error) {
            console.error(
              "Hulk+PluralCart: Failed to remove probe item from cart after retry.",
              firstError,
              error,
            );
          }
        }
      }
    }

    return values;
  };

  const appendHulkFileUrlInput = (form, input, value) => {
    if (form.contains(input)) {
      input.disabled = true;
      input.setAttribute(HULK_FILE_DISABLED_ATTR, "true");
    }

    const hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = input.name;
    hidden.value = value;
    hidden.setAttribute(HULK_FILE_URL_ATTR, "true");
    form.appendChild(hidden);
  };

  const hasPreparedHulkFileUrls = (form) => {
    return Boolean(form?.querySelector(`[${HULK_FILE_URL_ATTR}="true"]`));
  };

  const prepareHulkFileUrlsForPluralCart = async (productId) => {
    const form = getCurrentProductForm()?.querySelector("form");
    const wrapper = getHulkWrapper(productId);

    if (!form || !wrapper) {
      return true;
    }

    clearHulkFileUrlInputs(form);

    const fileInputs = [
      ...wrapper.querySelectorAll(HULK_FILE_PROPERTY_SELECTOR),
    ].filter((input) => {
      return !input.disabled && Boolean(input.files?.[0]);
    });

    if (!fileInputs.length) {
      return true;
    }

    try {
      const fileUrls = await getHulkFileUrlsFromCartProbe(form, fileInputs);

      return fileInputs.every((input) => {
        const value = fileUrls[input.name];
        if (!value) return false;
        appendHulkFileUrlInput(form, input, value);
        return true;
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const scheduleModalDecoration = () => {
    window.clearTimeout(state.modalDecorateTimerId);
    state.modalDecorateTimerId = window.setTimeout(() => {
      const openModals = [
        ...document.querySelectorAll(PLURAL_CART_MODAL_OPEN_SELECTOR),
      ];
      const openModalKey = openModals.map((modal) => modal.id).join("|");

      if (!openModals.length) {
        const form = getCurrentProductForm()?.querySelector("form");

        if (form) {
          clearHulkFileUrlInputs(form);
        }
      }

      if (openModalKey !== state.lastOpenModalKey) {
        state.savedCartIntakeCache = {};
        state.savedCartDetailPromises = {};
        state.currentCartHasIntakePromise = null;
        document.querySelectorAll(`[${DRAFT_NAME_PREFILLED_ATTR}]`).forEach(
          (el) => el.removeAttribute(DRAFT_NAME_PREFILLED_ATTR),
        );
        state.lastOpenModalKey = openModalKey;
      }

      openModals.forEach((modal) => {
        handlePluralCartSuccessRedirect(modal);
        handleCartPageSaveToDraftSuccess(modal);
        prefillDraftCartName(modal);
        decoratePluralCartModal(modal);
      });
    }, 50);
  };

  const handlePluralCartClick = async (event) => {
    const expandButton = event.target.closest(PLURAL_CART_EXPAND_SELECTOR);
    const triggerButton =
      !expandButton && event.target.closest(PLURAL_CART_TRIGGER_SELECTOR);

    if (!expandButton && !triggerButton) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (state.clickHandlerInFlight) {
      return;
    }

    state.clickHandlerInFlight = true;

    try {
      const button = expandButton || triggerButton;
      const productId = getProductIdFromElement(button);
      const isValid = await isHulkValid(productId);

      if (isValid) {
        const filesPrepared = await prepareHulkFileUrlsForPluralCart(
          productId || getCurrentProductId(),
        );

        if (filesPrepared) {
          openPluralCartModal();
        } else {
          showHulkFilePreparationError();
        }
      }
    } finally {
      state.clickHandlerInFlight = false;
    }
  };

  const installBridge = async () => {
    if (!window.cartSaver) {
      return false;
    }

    if (!state.baseBridgeInstalled) {
      document.addEventListener("click", handleDisabledCartInteraction, true);
      document.addEventListener("keydown", handleDisabledCartKeydown, true);
      installDisabledCartStyles();
      installModalObserver();
      state.baseBridgeInstalled = true;
    }

    const requiresHulkValidation =
      isProductTemplate() && document.querySelector(PRODUCT_FORM_SELECTOR);

    if (!requiresHulkValidation) {
      return true;
    }

    if (!state.hulkBridgeInstalled) {
      window.cartSaver.validationCallback = async () => {
        const isValid = await isHulkValid();
        const form = getCurrentProductForm()?.querySelector("form");

        if (!isValid) {
          closePluralCartModal();
          return { success: false };
        }

        const filesPrepared =
          hasPreparedHulkFileUrls(form) ||
          (await prepareHulkFileUrlsForPluralCart(getCurrentProductId()));

        if (!filesPrepared) {
          closePluralCartModal();
          showHulkFilePreparationError();
        }

        return { success: filesPrepared };
      };

      document.addEventListener("pc-cart:invalid", closePluralCartModal);
      document.addEventListener("click", handlePluralCartClick, true);
      state.hulkBridgeInstalled = true;
    }

    return true;
  };

  const getDraftCartIdFromUrl = () => {
    const match = window.location.pathname.match(DRAFT_CART_PATH_PATTERN);
    return match ? match[1] : null;
  };

  const isDraftCartPage = () => Boolean(getDraftCartIdFromUrl());

  const deleteDraftCart = async (cartId) => {
    const response = await fetch(
      `/a/saved-carts/${encodeURIComponent(cartId)}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to delete draft cart: ${response.status}`);
    }
  };

  const deleteLineItem = async (cartId, lineItemId) => {
    const response = await fetch(
      `/a/saved-carts/${encodeURIComponent(cartId)}/line_items/${encodeURIComponent(lineItemId)}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      },
    );

    if (!response.ok) {
      throw new Error(`Failed to delete line item: ${response.status}`);
    }
  };

  const getDraftCartName = () => {
    return (
      document.querySelector("h1")?.textContent?.trim() ||
      document.querySelector(".cs-title")?.textContent?.trim() ||
      document.title?.trim() ||
      "this draft cart"
    );
  };

  // Shared completion for "Add All to Cart" — called from pc-cart:added (non-empty cart)
  // or the fetch interceptor (empty cart). The addAllCompleting guard ensures only one
  // path can run to completion.
  const completeAddAll = async ({ awaitDelete }) => {
    if (state.addAllCompleting) {
      return;
    }

    state.addAllCompleting = true;
    state.addAllInFlight = false;
    window.clearTimeout(state.addAllTimeoutId);

    if (state.addAllModalCloseHandler) {
      document.removeEventListener('click', state.addAllModalCloseHandler, true);
      state.addAllModalCloseHandler = null;
    }

    const cartId = getDraftCartIdFromUrl();

    if (cartId) {
      if (awaitDelete) {
        try {
          await deleteDraftCart(cartId);
        } catch (error) {
          console.error("Draft cart: failed to delete after Add All", error);
          alert("Could not delete the draft cart. Please try again.");
          state.addAllCompleting = false;
          return;
        }
      } else {
        deleteDraftCart(cartId).catch((error) => {
          console.error("Draft cart: failed to delete after Add All (non-blocking)", error);
        });
      }
    }

    window.location.assign("/cart");
  };

  // Shared pc-cart:added handler — supports both "Add All" and "Add Single" flows.
  // When addAllInFlight is true, each pc-cart:added decrements the counter;
  // at zero we delete the draft cart and redirect to /cart.
  const installDraftCartHandlers = () => {
    if (state.draftCartHandlersInstalled) {
      return;
    }

    state.draftCartHandlersInstalled = true;

    // Intercept fetch to detect when /cart/add.js completes for single-item adds
    const originalFetch = window.fetch;

    const getUrlFromFetchArgs = (input) =>
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.href
          : input?.url ?? "";

    window.fetch = async (...args) => {
      let response;
      try {
        response = await originalFetch(...args);
      } catch (error) {
        // Network error — clear pending state so single-item adds are not permanently blocked.
        if (/\/cart\/add(\.js)?([?#]|$)/.test(getUrlFromFetchArgs(args[0])) && state.pendingSingleLineItemId) {
          window.clearTimeout(state.pendingSingleTimeoutId);
          state.pendingSingleLineItemId = null;
          state.pendingSingleCartId = null;
        }
        throw error;
      }

      const url = getUrlFromFetchArgs(args[0]);

      // Empty-cart "Add All" path: PluralCart skips the Merge/Replace modal and adds
      // items directly via /cart/add.js. Complete the flow before returning the response
      // so deleteDraftCart fires before PluralCart navigates away.
      if (
        /\/cart\/add(\.js)?([?#]|$)/.test(url) &&
        state.addAllInFlight &&
        state.addAllCartWasEmpty
      ) {
        if (response.ok && !state.addAllCompleting) {
          await completeAddAll({ awaitDelete: false });
        } else if (!response.ok) {
          window.clearTimeout(state.addAllTimeoutId);
          state.addAllInFlight = false;
          state.addAllCartWasEmpty = false;
        }
        return response;
      }

      if (/\/cart\/add(\.js)?([?#]|$)/.test(url) && state.pendingSingleLineItemId) {
        if (!response.ok) {
          // Failed response — clear pending state so single-item adds are not permanently blocked.
          window.clearTimeout(state.pendingSingleTimeoutId);
          state.pendingSingleLineItemId = null;
          state.pendingSingleCartId = null;
        } else {
          window.clearTimeout(state.pendingSingleTimeoutId);
          const cartId = state.pendingSingleCartId;
          const lineItemId = state.pendingSingleLineItemId;
          state.pendingSingleLineItemId = null;
          state.pendingSingleCartId = null;

          deleteLineItem(cartId, lineItemId)
            .then(() => {
              window.location.reload();
            })
            .catch((error) => {
              console.error("Draft cart: failed to remove line item", error);
              alert("Could not remove the item from the draft cart. Please try again.");
            });
        }
      }

      return response;
    };

    document.addEventListener("pc-cart:added", async () => {
      if (state.addAllInFlight && !state.addAllCartWasEmpty) {
        state.addAllItemsAdded = (state.addAllItemsAdded || 0) + 1;

        if (state.addAllItemsAdded >= state.addAllItemsTotal) {
          await completeAddAll({ awaitDelete: true });
        }

        return;
      }
    });

    document.addEventListener("click", handleAddAllToCartClick, true);
    document.addEventListener("click", handleAddSingleToCartClick, true);
  };

  const handleAddSingleToCartClick = (event) => {
    const button = event.target.closest(ADD_SINGLE_TO_CART_SELECTOR);

    if (!button || state.addAllInFlight) {
      return;
    }

    // Block if a single-item add is already in-flight to prevent race condition
    // where rapid successive clicks overwrite pendingSingleLineItemId and delete wrong item.
    if (state.pendingSingleLineItemId) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const container = button.closest("[id^='line_item_']");
    if (!container) return;

    const match = container.id.match(/^line_item_(\d+)$/);
    if (!match) return;

    state.pendingSingleLineItemId = match[1];
    state.pendingSingleCartId = getDraftCartIdFromUrl();

    // Safety timeout: if the fetch interceptor never sees a /cart/add.js response
    // (e.g. PluralCart modal dismissed before fetch), clear pending state so
    // single-item adds are not permanently blocked.
    window.clearTimeout(state.pendingSingleTimeoutId);
    state.pendingSingleTimeoutId = window.setTimeout(() => {
      if (state.pendingSingleLineItemId) {
        state.pendingSingleLineItemId = null;
        state.pendingSingleCartId = null;
      }
    }, 30000);
  };

  const handleAddAllToCartClick = async (event) => {
    const button = event.target.closest(ADD_ALL_TO_CART_SELECTOR);

    if (!button) {
      return;
    }

    // Let synthetic confirmed clicks pass through to PluralCart directly.
    if (event.__addAllConfirmed) {
      return;
    }

    if (state.addAllInFlight || state.confirmInProgress) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Prevent the event from reaching PluralCart immediately — we need to confirm first.
    // After confirmation we dispatch a fresh click on the button to trigger PluralCart.
    event.preventDefault();
    event.stopImmediatePropagation();

    state.confirmInProgress = true;

    const cartName = getDraftCartName();
    const confirmed = await showConfirmDialog(
      'Add All to Cart',
      `Transfer all items to Cart and delete Draft Cart "${cartName}"?`,
    );

    state.confirmInProgress = false;

    if (!confirmed) {
      return;
    }

    // Detect whether the live cart is empty — this determines which completion path fires.
    let cartWasEmpty = false;
    try {
      const cart = await fetchJson("/cart.js");
      cartWasEmpty = cart.item_count === 0;
    } catch {
      // Fall back to the proven non-empty path on any fetch error.
    }

    // PluralCart's replaceCart action fires a single pc-cart:added for the whole batch,
    // regardless of how many items are in the draft cart.
    state.addAllItemsTotal = 1;
    state.addAllItemsAdded = 0;
    state.addAllInFlight = true;
    state.addAllCartWasEmpty = cartWasEmpty;
    state.addAllCompleting = false;

    // Re-dispatch a fresh click with a marker so our handler lets it pass through to PluralCart.
    const syntheticClick = new MouseEvent('click', { bubbles: true, cancelable: true });
    syntheticClick.__addAllConfirmed = true;
    button.dispatchEvent(syntheticClick);

    window.clearTimeout(state.addAllTimeoutId);

    const resetAddAll = () => {
      if (state.addAllInFlight) {
        state.addAllInFlight = false;
        state.addAllItemsAdded = 0;
        state.addAllItemsTotal = 0;
        state.addAllCartWasEmpty = false;
        state.addAllCompleting = false;
      }
    };

    // When the cart is non-empty, PluralCart shows a Merge/Replace modal.
    // Watch for it being dismissed without completing so the next click works.
    // When the cart is empty, PluralCart skips the modal entirely — no watcher needed.
    if (!cartWasEmpty) {
      const onPluralCartModalClose = (e) => {
        const isCloseButton = e.target.closest('[data-action*="hideModal"]');
        const isBackdropClick = e.target.classList.contains('cs-modal__overlay');
        if (isCloseButton || isBackdropClick) {
          window.clearTimeout(state.addAllTimeoutId);
          resetAddAll();
          document.removeEventListener('click', onPluralCartModalClose, true);
        }
      };

      state.addAllModalCloseHandler = onPluralCartModalClose;
      document.addEventListener('click', onPluralCartModalClose, true);
    }

    // Safety timeout: reset addAllInFlight after 30s as a fallback.
    state.addAllTimeoutId = window.setTimeout(() => {
      resetAddAll();
      if (state.addAllModalCloseHandler) {
        document.removeEventListener('click', state.addAllModalCloseHandler, true);
        state.addAllModalCloseHandler = null;
      }
    }, 30000);
  };

  const init = async () => {
    let attempts = 0;

    if (isDraftCartPage()) {
      installDraftCartHandlers();
    }

    while (attempts < MAX_INIT_ATTEMPTS) {
      if (await installBridge()) {
        scheduleModalDecoration();
        return;
      }

      attempts += 1;
      await wait(INIT_RETRY_DELAY_MS);
    }
  };

  init();
})();
